// extracted by css-extract-rspack-plugin
export default {"preview":"MarkdownPreview-module__preview___k0hXO","oneLine":"MarkdownPreview-module__oneLine___Z7Qpw"};